(function () {
  if (window.__psInitialized) return;
  window.__psInitialized = true;

  var initializedSections = new WeakSet();

  function initSection(root) {
    if (!root || initializedSections.has(root)) return;
    initializedSections.add(root);

    var revealEls = root.querySelectorAll('[data-ps-reveal]');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el, i) {
      if (el.classList.contains('ps__problem')) {
        el.style.transitionDelay = (i * 70) + 'ms';
      }
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ps]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ps]');
    if (root) {
      initializedSections.delete(root);
      root.querySelectorAll('[data-ps-reveal]').forEach(function (el) {
        el.classList.remove('is-visible');
      });
      initSection(root);
    }
  });
})();